<div class="main-container" data-selenium="building-integrations-container">
<h2 class="page-title" data-selenium="building-integrations-title">{{ "building_integrations.BUILDING_INTEGRATIONS" | translate }}</h2>

<div class="contextual-message-wrapper" *ngIf="showContextualMessage" data-selenium="contextual-message">
  <ia-contextual-message type="info">
    <span class="text-in-blue">{{ 'building_integrations.CONTEXTUAL_MESSAGE_ON_BUILDING_INTEGRATION_MSG1' | translate
      }}</span>
    <span>{{ 'building_integrations.CONTEXTUAL_MESSAGE_ON_BUILDING_INTEGRATION_MSG2' | translate }}</span>
  </ia-contextual-message>
</div>


<!-- New section for bacnet enabling -->
 @if(bacnetEnabledFlag){
<div class="integration-wrapper" data-selenium="bacnet-integration-section">
  <div class="section-header">
    <h3 class="title-header" data-selenium="bacnet-title">{{ "building_integrations.BACNET" | translate }}</h3>
    <ia-tooltip content="{{ 'building_integrations.BACNET_TOOLTIP' | translate }}"
      title="{{ 'building_integrations.BACNET_TOOLTIP_HEADER' | translate }}" position="bottom-left" theme="primary">
      <span class="info-icon"></span>
    </ia-tooltip>
  </div>

  <div class="row-container">
    @if(BACnetBuildingData.length > 0){
    <div class="enabled-row-info" data-selenium="bacnet-enabled-status">
      <div class="status-info">
        <img class="export-icon" [src]="getConnectedIconUrl()" alt="Export" />
        <span class="file-name" data-selenium="bacnet-enabled-text">{{"building_integrations.ENABLED" | translate }}</span>
      </div>
    </div>
    } @else {
    <div class="disabled-row-info" data-selenium="bacnet-disabled-status">
      <div class="status-info">
        <img class="export-icon" [src]="getNotConnectedIconUrl()" alt="Export" />
        <span class="file-name" data-selenium="bacnet-disabled-text">{{"building_integrations.NOTENABLED" | translate }}</span>
      </div>
      <ia-button data-selenium="enable-bacnet-btn" (click)="enableBacnet()" (keydown)="enableBacnet()" [disabled]="isEnablingBacnet">{{
        "building_integrations.ENABLE_BACNET" | translate
        }}</ia-button>
    </div>
    }
  </div>


</div>
 }
<!-- New section for on prem enabling -->
<div class="integration-wrapper" data-selenium="api-integration-section">
  <div class="section-header">
    <h3 class="title-header" data-selenium="api-title">{{ "building_integrations.API_CONNECTION" | translate }}</h3>
    <ia-tooltip content="{{ 'building_integrations.API_TOOLTIP' | translate }}"
      title="{{ 'building_integrations.API_TOOLTIP_HEADER' | translate }}" position="bottom-left" theme="primary">
      <span class="info-icon"></span>
    </ia-tooltip>
  </div>

  <div class="row-container">
    @if(isProjectDownloadPaid || gatewayAPIbuildingData.length > 0){
    <div class="enabled-row-info" data-selenium="api-enabled-status">
      <div class="status-info">
        <img class="export-icon" [src]="getConnectedIconUrl()" alt="Export" />
        <span class="file-name" data-selenium="api-enabled-text">{{"building_integrations.ENABLED" | translate }}</span>
      </div>

    </div>
    } @else {
    <div class="disabled-row-info" data-selenium="api-disabled-status">
      <div class="status-info">
        <img class="export-icon" [src]="getNotConnectedIconUrl()" alt="Export" />
        <span class="file-name" data-selenium="api-disabled-text">{{"building_integrations.NOTENABLED" | translate }}</span>
      </div>
      <span data-selenium="contact-signify-message">
        <a href="https://www.signify.com/global/contact" target="_blank" data-selenium="contact-signify-link">{{
          "building_integrations.CONTACT_SIGNIFY_TO_ENABLE_APICONNECTION_PART1" | translate }}
        </a>
        {{ "building_integrations.CONTACT_SIGNIFY_TO_ENABLE_APICONNECTION_PART2" | translate }}
        </span>
    </div>
    }
  </div>
  <!-- Section for certificates component -->
  <ph-certificates class="certificates-component" data-selenium="certificates-component" *ngIf="isProjectDownloadPaid || gatewayAPIbuildingData.length > 0"
    [projectId]="projectId" [accessToken]="accessToken" [projectCode]="projectCode" [projectName]="projectName"
    [language]="language"></ph-certificates>
</div>

<!-- Section for project data and instructions -->
<div class="integration-wrapper" data-selenium="project-data-section">
  <div class="section-header" *ngIf="(isProjectDownloadPaid && !isAdmin) || buildingData.length > 0">
    <h3 class="title-header" data-selenium="project-data-title">{{ "building_integrations.PROJECTDATA_AND_INSTRUCTIONS" | translate }}</h3>
    <ia-tooltip content="{{ 'building_integrations.PROJECT_DATA_TOOLTIP' | translate }}"
      title="{{ 'building_integrations.PROJECT_DATA' | translate }}" position="bottom-left" theme="primary">
      <span class="info-icon"></span>
    </ia-tooltip>
  </div>


  <div class="integration-sections-container">
    <!--Section for Gateway API cards-->
    <div class="gateway-api-section" data-selenium="gateway-api-section" *ngIf="isProjectDownloadPaid || gatewayAPIbuildingData.length > 0">
      <div class="card" data-selenium="gateway-api-project-data-card" *ngIf="!isAdmin">
        <div class="file-info">
          <span class="file-icon"></span>
          <span class="file-name" data-selenium="gateway-api-project-data-filename">{{
            "building_integrations.PROJECT_DATA_FOR_GATEWAYRESTAPI" | translate
            }}</span>
        </div>
        <button class="download-btn" data-selenium="download-project-data-btn" *ngIf="!preparingDownload" (click)="downloadProjectData()" (keydown)="onDownloadProjectDataKey($event)"
          aria-label="Download file" type="button">
          <span class="download-icon"></span>
        </button>

        <ng-container *ngIf="preparingDownload">
          <div class="download-cell" data-selenium="preparing-download-loader">
            <ia-loader></ia-loader>
            {{ 'building_integrations.PREPARING_DOWNLOAD' | translate }}
          </div>
        </ng-container>
      </div>

      <div class="card" data-selenium="gateway-api-instructions-card" *ngFor="let integration of gatewayAPIbuildingData">
        <div class="file-info">
          <span class="file-icon"></span>
          <span class="file-name" data-selenium="gateway-api-instructions-filename">{{"building_integrations.INSTRUCTIONS_GATEWAYRESTAPI" | translate }}</span>
        </div>
        <a class="download-btn" data-selenium="gateway-api-instructions-link" [href]="integration?.instructionFile" target="_blank" rel="noopener noreferrer"
          aria-label="Export file">
          <img class="export-icon" [src]="getExportIconUrl()" alt="Export" />
        </a>
      </div>
    </div>
    <!-- Section for BACNET-->
    <div class="bacnet-section" data-selenium="bacnet-downloads-section" *ngIf="bacnetEnabledFlag && BACnetBuildingData.length > 0">
      <div class="card" data-selenium="bacnet-project-data-card">
        <div class="file-info">
          <span class="file-icon"></span>
          <span class="file-name" data-selenium="bacnet-project-data-filename">{{
            "building_integrations.PROJECT_DATA_FOR_BACNET" | translate
            }}</span>
        </div>
        <button class="download-btn" data-selenium="download-bacnet-data-btn" *ngIf="!preparingBACnetDownload" (click)="downloadBACnetProjectData()"
          (keydown)="onDownloadKey($event)" aria-label="Download file" type="button">
          <span class="download-icon"></span>
        </button>


        <ng-container *ngIf="preparingBACnetDownload">
          <div class="download-cell" data-selenium="preparing-bacnet-download-loader">
            <ia-loader></ia-loader>
            {{ 'building_integrations.PREPARING_DOWNLOAD' | translate }}
          </div>
        </ng-container>
      </div>

      <div class="card" data-selenium="bacnet-instructions-card" *ngFor="let integration of BACnetBuildingData">
        <div class="file-info">
          <span class="file-icon"></span>
          <span class="file-name" data-selenium="bacnet-instructions-filename">{{"building_integrations.INSTRUCTIONS_BACNET" | translate }}</span>
        </div>
        <a class="download-btn" data-selenium="bacnet-instructions-link" [href]="integration?.instructionFile" target="_blank" rel="noopener noreferrer"
          aria-label="Export file">
          <img class="export-icon" [src]="getExportIconUrl()" alt="Export" />
        </a>
      </div>
    </div>
  </div>
</div>
</div>
